import {useMainStore} from "../Stores/store";

type UserType = {
    id?: number;
    first_name?: string;
    last_name?: string;
    name: string;
    email?: string;
    roles?: Array<{
        name: string;
    }>;
    permissions?: Array<string>;
    profile?: any;
};

class User {
    public user: UserType;

    constructor(user: UserType | null = null) {
        if (user) {
            this.user = user;
        } else {
            const $store = useMainStore();
            this.user = $store?.user;
        }
    }

    static from(usr: UserType) {
        return new User(usr);
    }

    value(key: string | null = null, val = null) {
        const validKey = key && key in this.user && val;

        if (validKey) {
            this.user[key as keyof typeof this.user] = val;
        } else {
            if (key) {
                return key.split(".")?.reduce((a: {[key: string]: any}, b) => a[b] ?? "", this.user) ?? "";
            }
        }
        return this.user;
    }

    get id() {
        return this.user.id;
    }

    get roles(): Array<{
        name: string;
    }> {
        return this.user.roles ?? [];
    }

    get profile() {
        return this.user.profile ?? {};
    }

    get permissions() {
        return this.user.permissions ?? [];
    }

    get role(): string {
        return this.roles[0]?.name;
    }

    hasRole(role: string): boolean {
        return this.roles.some((r) => r.name === role) ?? false;
    }

    hasAnyRole(roles: Array<string>): boolean {
        return this.roles.some((role) => roles.includes(role.name));
    }

    can(permission: string | Array, any: boolean = true): boolean {
        if (this.role === "super-admin") {
            return true;
        }

        if (Array.isArray(permission)) {
            if (any) {
                return this.permissions.some((p) => permission.includes(p));
            } else {
                return permission.every((p) => this.permissions.includes(p));
            }
        }

        return this.permissions.includes(permission);
    }

    get name(): string {
        return `${this.user.first_name} ${this.user.last_name}`;
    }

    get initials(): string {
        return this.user?.initials || (this.user?.first_name?.[0] + this.user?.last_name?.[0])?.toUpperCase();
    }

    get(key: string) {
        return this.user[key as keyof UserType];
    }
}

export default User;
